var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import getTheme from "../Theme";
import { Avatar, Button, Card, CardActions, CardContent, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, LinearProgress, Radio, RadioGroup, Stack, TextField, Typography, } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useFileUploader } from "../hooks/useFileUploader";
import { AddAPhoto, Close, 
//  PersonAdd,
//  Place,
Edit, IosShare, } from "@mui/icons-material";
import { ContentCard } from "./ContentCard";
import { saveChannelData } from "../util/DataUtils";
import { authUrl, useCacheBusterStore } from "../util/UrlUtils";
import { useLogger } from "../logger";
import { useChannelDataLoader } from "../hooks/useChannelDataLoader";
export const EditChannelCard = (props) => {
    const cacheBusterStore = useCacheBusterStore((state) => state);
    const channelDataLoader = useChannelDataLoader();
    const canvasRef = useRef(null);
    // Check if this is a Feed channel (channel owner ID equals channel ID)
    const isFeedChannel = props.channelOwnerId === props.channelId;
    const [editChannelTitle, setEditChannelTitle] = useState(props.title ? props.title : "");
    const [editChannelHelperTitle, setEditChannelHelperTitle] = useState(undefined);
    const [editChannelSubtitle, setEditChannelSubtitle] = useState(props.subtitle ? props.subtitle : "");
    const [editChannelHelperSubtitle, setEditChannelHelperSubtitle] = useState(undefined);
    const [editChannelText, setEditChannelText] = useState(props.description ? props.description : "");
    const [editChannelHelperText, setEditChannelHelperText] = useState(undefined);
    const [permissionsAdultContent, setPermissionsAdultContent] = useState(props.permissions.permissionsAdultContent);
    const [permissionsAllowsComments, setPermissionsAllowsComments] = useState(props.permissions.permissionsAllowsComments);
    const [permissionsAllowsPosts, setPermissionsAllowsPosts] = useState(props.permissions.permissionsAllowsPosts);
    const [editChannelPrompt, setEditChannelPrompt] = useState(props.memberPrompt ? props.memberPrompt : "");
    const [editChannelHelperPrompt, setEditChannelHelperPrompt] = useState(undefined);
    const [editChannelImageUrl, setEditChannelImageUrl] = useState(props.imageUrl ? props.imageUrl : "");
    const [editChannelSaving, setEditChannelSaving] = useState(false);
    const [editChannelSavedOk, setEditChannelSavedOk] = useState(false);
    const [editChannelSaveError, setEditChannelSaveError] = useState(undefined);
    const hiddenFileInputEditChannel = useRef(null);
    const [editChannelImageDataUrl, setEditChannelImageDataUrl] = useState(props.imageUrl || "");
    const [access, setAccess] = useState(props.privateChannel ? "private" : "public");
    const [errorMessage, setErrorMessage] = useState();
    const [tempFile, setTempFile] = useState(null);
    const [tempImageDataUrl, setTempImageDataUrl] = useState("");
    const [tempImagePath, setTempImagePath] = useState("");
    const [uploadingImage, setUploadingImage] = useState(false);
    const [imageUploaded, setImageUploaded] = useState(false);
    const logger = useLogger((state) => state);
    // File uploader hook
    const fileUploader = useFileUploader({
        maxImageSize: 50 * 1024 * 1024,
        acceptedFileTypes: ["image/jpeg", "image/png"],
        onUploadError: (error) => {
            logger.error("EditChannelCard: Upload error: " + error.message);
            setErrorMessage(error.message);
            setUploadingImage(false);
        },
    });
    const validateEditChannelTitle = (title) => {
        setEditChannelSaveError(undefined);
        setEditChannelSaving(false);
        if (!title) {
            setEditChannelHelperTitle(undefined);
            return;
        }
        if (title.includes("<")) {
            setEditChannelHelperTitle("Title cannot contain '<' character.");
        }
        else if (title.includes("@")) {
            setEditChannelHelperTitle("Title cannot contain '@' character.");
        }
        else if (title.includes("\n")) {
            setEditChannelHelperTitle("Title cannot contain newline character.");
        }
        else {
            setEditChannelHelperTitle(undefined);
        }
    };
    const validateeditChannelSubtitle = (title) => {
        setEditChannelSaveError(undefined);
        setEditChannelSaving(false);
        if (!title) {
            setEditChannelHelperSubtitle(undefined);
            return;
        }
        if (title.includes("<")) {
            setEditChannelHelperSubtitle("Subtitle cannot contain '<' character.");
        }
        else if (title.includes("\n")) {
            setEditChannelHelperSubtitle("Subtitle cannot contain newline character.");
        }
        else {
            setEditChannelHelperSubtitle(undefined);
        }
    };
    const validateEditChannelText = (text) => {
        setEditChannelSaveError(undefined);
        setEditChannelSaving(false);
        if (!text) {
            setEditChannelHelperText(undefined);
            return;
        }
        if (text.includes("<")) {
            setEditChannelHelperText("Text cannot contain '<' character.");
        }
        else {
            setEditChannelHelperText(undefined);
        }
    };
    const validateEditChannelPrompt = (prompt) => {
        setEditChannelSaveError(undefined);
        setEditChannelSaving(false);
        if (!prompt) {
            setEditChannelHelperPrompt(undefined);
            return;
        }
        if (prompt.includes("<")) {
            setEditChannelHelperPrompt("Member question cannot contain '<' character.");
        }
        else if (prompt.includes("\n")) {
            setEditChannelHelperPrompt("Member question cannot contain newline character.");
        }
        else {
            setEditChannelHelperPrompt(undefined);
        }
    };
    const doPublish = () => {
        logger.log("EditChannelCard: doPublish");
        // Capture expected timestamp for polling - this should match what the backend will set
        const expectedTimestamp = Date.now();
        const handleError = (errorMessage) => {
            logger.log("EditChannelCard: doPublish: handleError " + errorMessage);
            setTimeout(() => {
                setEditChannelSaveError(errorMessage);
                setEditChannelSavedOk(false);
                setEditChannelSaving(false);
            }, 300);
        };
        const handleOk = () => {
            logger.log("EditChannelCard: doPublish: handleOk");
            setEditChannelSaving(false);
            setEditChannelSaveError(undefined);
            // Clean up temp file blob URL
            if (tempImageDataUrl && tempImageDataUrl.startsWith("blob:")) {
                URL.revokeObjectURL(tempImageDataUrl);
                setTempImageDataUrl("");
            }
            setTimeout(() => {
                setEditChannelSavedOk(true);
            }, 300);
        };
        setEditChannelSaveError(undefined);
        setEditChannelSavedOk(false);
        setEditChannelSaving(true);
        if (!props.auth || !props.auth.isSignedIn() || !props.auth.userId) {
            logger.error("EditChannelCard: User not signed in.");
            handleError("User is not signed in.");
            return;
        }
        const inputData = {
            title: editChannelTitle,
            subtitle: editChannelSubtitle,
            description: editChannelText,
            channelOwnerId: props.auth.userId,
            channelId: props.channelId,
            membershipPrompt: isFeedChannel ? "" : editChannelPrompt,
            private: access == "private" ? true : false,
            tempImagePath: tempImagePath || undefined,
            permissions: {
                permissionsAdultContent,
                permissionsAllowsComments,
                permissionsAllowsPosts: isFeedChannel ? false : permissionsAllowsPosts,
                permissionsAllowsDiscovery: true,
            },
        };
        logger.log("EditChannelCard: Saving Channel: " + JSON.stringify(inputData));
        logger.log("EditChannelCard: Expected timestamp for polling: " + expectedTimestamp);
        logger.log(`EditChannelCard: Temp image uploaded: ${imageUploaded}, temp file exists: ${!!tempFile}`);
        // Save channel data - backend will detect and process temp images automatically
        saveChannelData(inputData, {
            okCallback: (clientDetailCode) => {
                var _a;
                logger.log("EditChannelCard: okCallback: " + clientDetailCode);
                // If temp image was uploaded, wait 6 seconds for processing then trigger reload
                if (tempImagePath) {
                    logger.log("EditChannelCard: Waiting 6 seconds for image processing...");
                    setTimeout(() => {
                        var _a;
                        logger.log("EditChannelCard: Processing wait complete, triggering channel reload");
                        (_a = props.onChannelUpdated) === null || _a === void 0 ? void 0 : _a.call(props);
                        handleOk();
                    }, 6000);
                }
                else {
                    // For non-image updates, trigger reload immediately
                    (_a = props.onChannelUpdated) === null || _a === void 0 ? void 0 : _a.call(props);
                    handleOk();
                }
                return;
            },
            errorCallback: (clientDetailCode, errorMessage) => {
                handleError(errorMessage + " (" + clientDetailCode + ")");
                return;
            },
            authCallback: {
                isSignedIn: () => props.auth.isSignedIn(),
                bearer: () => props.auth.bearer,
                sequence: () => props.auth.sequence,
                setBearerAndSequence: (bearer, sequence) => {
                    props.auth.setBearerAndSequence(bearer, sequence, logger);
                },
                getAuth: () => {
                    return props.auth;
                },
            },
        }, cacheBusterStore, logger);
    };
    useEffect(() => {
        console.log("useEffect: editChannelPrompt = " + editChannelPrompt);
        validateEditChannelPrompt(editChannelPrompt);
        return () => { };
    }, [editChannelPrompt]);
    useEffect(() => {
        console.log("useEffect: editChannelText = " + editChannelText);
        validateEditChannelText(editChannelText);
        return () => { };
    }, [editChannelText]);
    useEffect(() => {
        console.log("useEffect: editChannelTitle = " + editChannelTitle);
        validateEditChannelTitle(editChannelTitle);
        return () => { };
    }, [editChannelTitle]);
    useEffect(() => {
        console.log("useEffect: editChannelSubtitle = " + editChannelSubtitle);
        validateeditChannelSubtitle(editChannelSubtitle);
        return () => { };
    }, [editChannelSubtitle]);
    useEffect(() => {
        console.log("useEffect: mount - editChannelSavedOk = " +
            editChannelSavedOk +
            ", editChannelTitle = " +
            editChannelTitle);
        if (editChannelSavedOk) {
            // Start polling for updated channel data instead of using fixed timeout
            channelDataLoader.loadChannelData({
                channelOwnerId: props.channelOwnerId,
                channelId: props.channelId,
                auth: props.auth,
                cacheBusterStore,
                logger,
                enablePolling: true,
                expectedData: {
                    title: editChannelTitle,
                    subtitle: editChannelSubtitle,
                    description: editChannelText,
                },
                onSuccess: () => {
                    logger.log("EditChannelCard: Channel data updated successfully!");
                    logger.log("EditChannelCard: Reloading entire page for fresh channel display");
                    // Navigate to channel view with channelOwnerId and channelId parameters instead of generic reload
                    const channelViewUrl = `/ChannelView?channelOwnerId=${props.channelOwnerId}&channelId=${props.channelId}`;
                    logger.log(`EditChannelCard: Redirecting to: ${channelViewUrl}`);
                    window.location.href = channelViewUrl;
                },
                onError: (error) => {
                    logger.error("EditChannelCard: Polling error: " + error);
                    // Even on error, reset state and reload
                    setEditChannelSavedOk(false);
                    setEditChannelTitle("");
                    setEditChannelSubtitle("");
                    setEditChannelText("");
                    setEditChannelImageUrl(undefined);
                    if (props.reload) {
                        props.reload(editChannelTitle);
                    }
                },
            });
        }
        return () => {
            console.log("useEffect: unmount - editChannelSavedOk");
        };
    }, [editChannelSavedOk]);
    useEffect(() => {
        console.log("useEffect: mount - editChannelSaveError = " + editChannelSaveError);
        if (editChannelSaveError) {
            setTimeout(() => {
                setEditChannelSaveError(undefined);
                setEditChannelSavedOk(false);
                setEditChannelTitle("");
                setEditChannelSubtitle("");
                setEditChannelText("");
                setEditChannelImageUrl(undefined);
                if (props.reload) {
                    props.reload(editChannelTitle);
                }
            }, 5000);
        }
        return () => {
            console.log("useEffect: unmount - editChannelSaveError");
        };
    }, [editChannelSaveError]);
    useEffect(() => {
        console.log("useEffect: mount - editChannelImageDataUrl = " +
            !!editChannelImageDataUrl);
        return () => {
            console.log("useEffect: unmount - editChannelImageDataUrl");
        };
    }, [editChannelImageDataUrl]);
    const editChannelImageFilenameChanged = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        logger.log("EditChannelCard: editChannelImageFilenameChanged");
        logger.log(`EditChannelCard: Channel owner ID: ${props.channelOwnerId}, Auth user ID: ${props.auth.userId}, Channel ID: ${props.channelId}`);
        if (!((_a = hiddenFileInputEditChannel.current) === null || _a === void 0 ? void 0 : _a.files) ||
            hiddenFileInputEditChannel.current.files.length === 0) {
            return;
        }
        const file = hiddenFileInputEditChannel.current.files[0];
        logger.log(`EditChannelCard: Selected file: ${file.name}, type: ${file.type}, size: ${file.size}`);
        // Clear any existing errors
        setErrorMessage(undefined);
        // Validate file type
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            setErrorMessage(`Unsupported file type: ${file.type}. Please select a JPEG or PNG image.`);
            return;
        }
        // Validate file size (50MB max)
        if (file.size > 50 * 1024 * 1024) {
            setErrorMessage("File size too large. Please select an image smaller than 50MB.");
            return;
        }
        // Set temp file and create blob URL for immediate preview
        setTempFile(file);
        const blobUrl = URL.createObjectURL(file);
        setTempImageDataUrl(blobUrl);
        setEditChannelImageDataUrl(blobUrl);
        setEditChannelImageUrl(blobUrl);
        logger.log(`EditChannelCard: Preview URL created: ${blobUrl}`);
        // Start upload to temp location immediately
        setUploadingImage(true);
        const timestamp = new Date().getTime();
        try {
            // Determine file extension based on original file type
            let fileType = "jpg";
            if (file.type === "image/png")
                fileType = "png";
            // Upload to temp location - backend will handle processing during save
            const tempPartition = `tmp/${props.auth.userId}/${props.channelId}`;
            const contentId = `channelImage_${timestamp}`;
            logger.log(`EditChannelCard: Uploading to temp location: ${tempPartition}/${contentId}.${fileType}`);
            yield fileUploader.uploadFile({
                file,
                contentId,
                partition: tempPartition,
                auth: props.auth,
                cacheBusterStore,
            });
            // Store the temp file path with original file type for backend
            const tempFilePath = `${tempPartition}/${contentId}.${fileType}`;
            setTempImagePath(tempFilePath);
            logger.log("EditChannelCard: Temp upload successful");
            logger.log(`EditChannelCard: Temp image path: ${tempFilePath}`);
            setUploadingImage(false);
            setImageUploaded(true);
        }
        catch (error) {
            logger.error(`EditChannelCard: Temp upload failed: ${error}`);
            setErrorMessage(`Upload failed: ${error.message}`);
            setUploadingImage(false);
            // Clean up blob URL on error
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
            setTempFile(null);
            setTempImageDataUrl("");
            setEditChannelImageDataUrl(props.imageUrl || "");
            setEditChannelImageUrl(props.imageUrl || "");
        }
    });
    const editChannelMediaClicker = () => {
        console.log("editChannelMediaClicker: edit Channel - upload - click");
        if (hiddenFileInputEditChannel.current) {
            console.log("editChannelMediaClicker: Edit Channel - upload - click: Click: hiddenFileInput");
            hiddenFileInputEditChannel.current.click();
        }
        else {
            console.error("editChannelMediaClicker: missing hidden file input reference");
        }
    };
    const editChannelCardContent = (_jsxs(Stack, Object.assign({ style: { padding: "10px" } }, { children: [!editChannelSavedOk && !editChannelSaving && (_jsx(TextField, { fullWidth: true, id: "outlined-multiline-static-title", label: "Title", color: "black", size: "small", onChange: (event) => {
                    const value = event.target.value;
                    console.log("edit Channel title onChange - " + value);
                    setEditChannelTitle(value);
                }, error: !!editChannelHelperTitle, helperText: editChannelHelperTitle, value: editChannelTitle, sx: { marginBottom: "8px" } }, "cards.editChannel.cardcontent.textfield.title")), !editChannelSavedOk && !editChannelSaving && (_jsx(TextField, { fullWidth: true, id: "outlined-multiline-static-subtitle", label: "Subtitle", color: "black", size: "small", onChange: (event) => {
                    const value = event.target.value;
                    console.log("Edit Channel subtitle onChange - " + value);
                    setEditChannelSubtitle(value);
                }, error: !!editChannelHelperSubtitle, helperText: editChannelHelperSubtitle, value: editChannelSubtitle, sx: { marginBottom: "8px" } }, "cards.editChannel.cardcontent.textfield.subtitle")), !editChannelSavedOk && !editChannelSaving && (_jsx(TextField, { fullWidth: true, id: "outlined-multiline-static", label: "Describe your channel here...", multiline: true, rows: 2, color: "black", onChange: (event) => {
                    const value = event.target.value;
                    console.log("edit channel text onChange - " + value);
                    setEditChannelText(value);
                }, error: !!editChannelHelperText, helperText: editChannelHelperText, value: editChannelText, sx: { marginBottom: "3px" } }, "cards.editChannel.cardcontent.textfield")), !editChannelSaving && !editChannelSavedOk && (_jsx(Button, Object.assign({ variant: editChannelImageUrl ? "outlined" : "contained", endIcon: _jsx(AddAPhoto, {}), onClick: () => {
                    editChannelMediaClicker();
                }, disabled: uploadingImage, sx: { marginBottom: "10px", marginTop: "5px" } }, { children: uploadingImage ? "UPLOADING..." : "SET PHOTO" }), "cards.editChannel.button.photo")), uploadingImage && (_jsxs(Stack, Object.assign({ spacing: 1, sx: { marginBottom: "10px" } }, { children: [_jsx(Typography, Object.assign({ variant: "body2", color: "primary" }, { children: "Uploading image..." })), _jsx(LinearProgress, {})] }))), !editChannelSavedOk && !editChannelSaving && _jsx(Divider, {}), !editChannelSaving && !editChannelSavedOk && (_jsx(FormControl, { children: _jsxs(FormGroup, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: [_jsx(Typography, Object.assign({ variant: "body1", color: "primary", gutterBottom: true }, { children: "ACCESS" }), "cards.settings.cardcontent.type.access"), _jsxs(RadioGroup, Object.assign({ "aria-labelledby": "radio-buttons-group-channel-access-label", defaultValue: props.privateChannel ? "private" : "public", name: "radio-buttons-group-channel-access-name", onChange: (event) => {
                                const value = event.target.value;
                                console.log("setAccess: " + value);
                                setAccess(value);
                            }, value: access }, { children: [_jsx(FormControlLabel, { value: "public", control: _jsx(Radio, {}), label: "Public - Anyone can view channel content." }), _jsx(FormControlLabel, { value: "private", control: _jsx(Radio, {}), label: isFeedChannel
                                        ? "Private - Only friends can view your feed."
                                        : "Private - Channel viewers must be approved by channel owner." })] }))] })) })), !editChannelSavedOk &&
                !editChannelSaving &&
                access == "private" &&
                !isFeedChannel && (_jsx(TextField, { fullWidth: true, id: "outlined-multiline-static-memberprompt", label: "What question do you want to ask potential members? (optional)", multiline: true, rows: 2, color: "black", onChange: (event) => {
                    const value = event.target.value;
                    console.log("edit channel prompt onChange - " + value);
                    setEditChannelPrompt(value);
                }, error: !!editChannelHelperPrompt, helperText: editChannelHelperPrompt, disabled: editChannelSaving, value: editChannelPrompt, sx: { marginBottom: "3px" } }, "cards.editChannel.cardcontent.memberprompt")), !editChannelSavedOk && !editChannelSaving && _jsx(Divider, {}), !editChannelSavedOk && !editChannelSaving && (_jsx(Typography, Object.assign({ variant: "body1", color: "primary", gutterBottom: true }, { children: "VIEWER PERMISSIONS" }), "cards.settings.cardcontent.type.permissions")), !editChannelSavedOk && !editChannelSaving && (_jsx(Stack, Object.assign({ direction: "column", sx: {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    peditingLeft: "15px",
                    peditingRight: "15px",
                } }, { children: _jsx(FormControl, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsxs(FormGroup, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: [_jsx(FormControlLabel, { label: "Posts contain adult content.", control: _jsx(Checkbox, { checked: permissionsAdultContent, onChange: (event) => {
                                        console.log("permissionsAdultContent - checked/unchecked: " +
                                            event.target.checked);
                                        setPermissionsAdultContent(event.target.checked);
                                    } }) }), !isFeedChannel && (_jsx(FormControlLabel, { label: "Viewers can post to the channel.", control: _jsx(Checkbox, { checked: permissionsAllowsPosts, onChange: (event) => {
                                        console.log("permissionsAllowsPosts - checked/unchecked: " +
                                            event.target.checked);
                                        setPermissionsAllowsPosts(event.target.checked);
                                    } }) })), _jsx(FormControlLabel, { label: "Viewers can comment on posts.", control: _jsx(Checkbox, { checked: permissionsAllowsComments, onChange: (event) => {
                                        console.log("permissionsAllowsComments - checked/unchecked: " +
                                            event.target.checked);
                                        setPermissionsAllowsComments(event.target.checked);
                                    } }) })] })) })) }))), _jsxs(Stack, Object.assign({ direction: "row", width: "100%", sx: { display: "flex", justifyContent: "center", marginTop: "5px" }, spacing: 1 }, { children: [_jsx("input", { type: "file", accept: "image/jpeg,image/png", ref: hiddenFileInputEditChannel, style: { display: "none" }, onChange: editChannelImageFilenameChanged }, "edit-Channel-hidden-file-input"), _jsx("canvas", { ref: canvasRef, style: { display: "none" } }, "canvas.newChannelcard"), (editChannelSaving ||
                        (editChannelSavedOk && channelDataLoader.polling)) && (_jsx(Card, Object.assign({ elevation: 0, sx: {
                            backgroundColor: editChannelSaving ? "#F0F8FF" : "#E8F5E8",
                            pediting: "4",
                            marginTop: "0.5em",
                        }, color: "text.primary" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "primary", gutterBottom: true }, { children: editChannelSaving ? "SAVING..." : "UPDATING..." })), _jsx(Typography, Object.assign({ variant: "body2", color: "black", sx: { marginBottom: "15px" } }, { children: editChannelSaving
                                        ? "Saving your channel settings..."
                                        : channelDataLoader.pollingMessage })), _jsx(LinearProgress, { variant: editChannelSaving ? "indeterminate" : "determinate", value: editChannelSaving
                                        ? undefined
                                        : channelDataLoader.pollingProgress, sx: { marginBottom: "10px" } }), !editChannelSaving && (_jsxs(Typography, Object.assign({ variant: "body2", color: "primary", sx: { textAlign: "center" } }, { children: [Math.round(channelDataLoader.pollingProgress), "% complete"] })))] }, "edit-Channel-combined-progress-content") }), "edit-Channel-combined-progress-card"))] }), "edit-Channel-stack-2-" + editChannelSavedOk), editChannelSaveError && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#FFEEEE", pediting: "4", marginTop: "0.5em" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "error", gutterBottom: true }, { children: "SAVE FAILED" })), _jsx(Typography, Object.assign({ variant: "body2" }, { children: editChannelSaveError }))] }, "edit-Channel-error-card-content") }), "edit-Channel-error-card")), editChannelSavedOk && !channelDataLoader.polling && (_jsx(Card, Object.assign({ elevation: 0, sx: { backgroundColor: "#EEFFEE", pediting: "4", marginTop: "0.5em" }, color: "text.error" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6", component: "div", color: "EEFFEE", gutterBottom: true }, { children: "SAVED" })), _jsxs(Typography, Object.assign({ variant: "body2", color: "black" }, { children: ["Your settings have been saved.", _jsx("br", {}), "(old images may be cached for 24 hours)"] }))] }, "edit-Channel-saved-ok-card-content") }), "edit-Channel-saved-ok-card" + editChannelSavedOk))] }), "Edit-Channel-stack-card-" + editChannelSavedOk + editChannelSaveError));
    const editChannelCardActions = (_jsxs(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center", pediting: 0, margin: 0 } }, { children: [!editChannelSaving && !editChannelSavedOk && (_jsx(Button, Object.assign({ endIcon: _jsx(IosShare, {}), variant: "contained", onClick: () => {
                    doPublish();
                }, sx: { margin: "0.5em" }, disabled: !editChannelTitle ||
                    !!editChannelHelperTitle ||
                    !!editChannelHelperSubtitle ||
                    !!editChannelHelperText ||
                    uploadingImage // Disable save button while image is uploading
             }, { children: "Save" }), "cards.editChannel.button.publish")), !editChannelSaving && !editChannelSavedOk && (_jsx(Button, Object.assign({ endIcon: _jsx(Close, {}), variant: "outlined", onClick: () => {
                    props.dismiss();
                }, sx: { margin: "0.5em" } }, { children: "Cancel" }), "cards.editChannel.button.close"))] }), "edit-Channel-card-actions"));
    let imageUrl = editChannelImageDataUrl;
    if (props.auth && imageUrl && imageUrl == editChannelImageUrl) {
        imageUrl = authUrl(imageUrl, cacheBusterStore, props.auth);
    }
    // If imageUrl is empty string, treat it as undefined so ContentCard shows fallback
    const finalImageUrl = imageUrl && imageUrl.trim() !== "" ? imageUrl : undefined;
    if (errorMessage) {
        return (_jsx(ContentCard, { title: "ERROR", keyStr: "error.message.card", textColor: "#000000", backgroundColor: "#FFEEEE", childComponent: _jsx(Typography, Object.assign({ variant: "body1" }, { children: errorMessage })), actions: _jsx(CardActions, Object.assign({ sx: { display: "flex", justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                        setErrorMessage(undefined);
                    } }, { children: "DISMISS" })) })) }));
    }
    const editChannelCard = (_jsx(ContentCard, { keyStr: "content.card.editChannel." +
            editChannelSavedOk +
            editChannelImageDataUrl, title: "Edit Channel Settings", backgroundColor: getTheme().palette.violet.contrastText, textColor: getTheme().palette.black.main, childComponent: editChannelCardContent, actions: editChannelCardActions, mediaUrl: editChannelSavedOk || editChannelSaving ? undefined : finalImageUrl, mediaFallbackUrl: "/img/channels_512.jpg", maxWidth: 0.5, overlayIcon: _jsx(Avatar, Object.assign({ sx: {
                marginLeft: "auto",
                backgroundColor: getTheme().palette.violet.light,
            } }, { children: _jsx(Edit, {}) }), "settings.overlay.edit.button"), onMediaClick: () => {
            editChannelMediaClicker();
        } }, "content.card.editChannel." +
        editChannelSavedOk +
        editChannelImageDataUrl));
    return editChannelCard;
};
